import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
const axios = require('axios')
Vue.use(Vuex)

let dbRequests = axios.create({
  baseURL: 'https://tibiawallstreet.herokuapp.com/api/v1',
  // baseURL: 'http://localhost:3000/api/v1',
  timeout: 20000,
  headers: {
    'authorization': process.env.API_TOKEN,
    'content-type': "application/json"
  }
})

export default new Vuex.Store({
  state: {
    itemSearched: "",
    worlds: undefined,
    worldsMetaData: undefined,
    worldSelected: undefined,
    items: undefined,
    itemsArray: [],
    itemsMetadata: {},
    categories: undefined,
    categorySelected: undefined,
    itemPrices: {},
    itemPricesByItemId: {},
    tibiaCoinPrice: 0,
    pricesLoaded: false,
    searchOption: "world",
    pricesLoadedByItemId: false,
    itemHistory: {},
    chartActive: false,
    transferItems: undefined,
    worldsData: undefined,
    worldFrom: '',
    worldTo: '',
    user: {},
    loginResponse: ""
  },
  mutations: {
    setWorldFrom(state,from) {
      state.worldFrom = from
    },
    setWorldTo(state,to) {
      state.worldTo = to
    },
    setItem(state, item) {
      state.itemSearched = item;
    },
    hideChart(state) {
      state.chartActive = false
    },
    setWorlds: (state, worlds) => {
      let worldsArray = []
      let metaData = {}
      worlds.data.forEach(element => {
        worldsArray.push(`${element.world}`)
        metaData[element.world] = element
      });
      state.worldsMetaData = metaData
      state.worlds = worldsArray
    },
    setCategories: (state, items) => {
      state.categories = Object.keys(items.data)

    },
    setItems: (state, items) => {
      state.items = items;
      state.itemsArray = [];
      state.itemsMetadata = {}
      const categories = Object.keys(items.data);
      for (let i = 0; i < categories.length; i++) {
        const itemsInCat = items.data[categories[i]]

        for (let k = 0; k < itemsInCat.length; k++) {
          state.itemsArray.push(itemsInCat[k].itemName)
          state.itemsMetadata[itemsInCat[k].itemName] = itemsInCat[k]
        }
      }
      
    },
    async getHistory(state, data) {
      const category = getCategory(data.itemName, state.items);
      state.worldSelected = data.world
      state.itemHistory = {}
      await dbRequests.get(`/market/items/item/history?category=${category}&item=${data.itemName}&world=${data.world}&time=${data.time}`).then((res) => {

        const auxResponse = res.data.data

        let categories = []
        let prices = [];
        for (let i = 0; i < auxResponse.length; i++) {
          let date = new Date(auxResponse[i].timestamp)
          categories.push(`${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`)
          prices.push(auxResponse[i].minSellValue)
        }
        state.itemHistory = {
          data: res.data.data,
          itemName: data.itemName,
          categories: categories,
          prices: prices
        };
        state.chartActive = true;
      })
    },
    async selectedWorld(state, world) {
      state.worldSelected = world
      state.pricesLoaded = false
      await dbRequests.get(`/market/items/worlds/${world}?category=tibia`).then((res) => {
        const auxResponse = res.data.data
        auxResponse.sort((a, b) => {
          return new Date(b.timestamp) - new Date(a.timestamp)
        })
        state.tibiaCoinPrice = auxResponse[0].minSellValue
      })
    },
    setWorldUndefined(state) {
      state.pricesLoaded = undefined
    },
    selectCategorie(state, selected) {
      state.categorySelected = selected
    },
    getWorldsItems: async (state, worldsData) => {

      let result = {};
      state.worldsData = worldsData
      state.transferItems = undefined

      if(!worldsData.from || !worldsData.to){
        return
      }
      await dbRequests.get(`/market/items/transfer?from=${worldsData.from}&to=${worldsData.to}`).then((res) => {
        const data = res.data.data
        const worlds = [worldsData.from, worldsData.to]
        for (let j = 0; j < worlds.length; j++) {
          for (let i = 0; i < state.itemsArray.length; i++) {
            let category = getCategory(state.itemsArray[i], state.items);
            const itemsInCategory = data[category]
            for (let k = 0; k < itemsInCategory.length; k++) {
              if (state.itemsArray[i] == itemsInCategory[k].itemName && itemsInCategory[k].world == worlds[j]) {
                if (itemsInCategory[k].itemName in result) {
                  result[itemsInCategory[k].itemName].push(itemsInCategory[k])
                } else {
                  result[itemsInCategory[k].itemName] = [itemsInCategory[k]]
                }
                break;
              }
            }
          }
        }
        
        const fromTcPrice = result['tibia coins'][0].minSellValue;
        const toTcPrice = result['tibia coins'][1].minSellValue;
        const items = Object.keys(result);
        let structuredData = []
        for(let i = 0; i < items.length; i++) {

          const item = items[i];

          structuredData.push({
            imgUrl: state.itemsMetadata[item].imgUrl,
            fromTcPrice: fromTcPrice,
            fromMinSellValue: result[item][0].minSellValue,
            fromTcItemValue: result[item][0].minSellValue/fromTcPrice,
            toTcPrice: toTcPrice,
            toMinSellValue: result[item][1].minSellValue,
            toTcItemValue: result[item][1].minSellValue/toTcPrice,
            profitGp: result[item][0].minSellValue - result[item][1].minSellValue,
            profitTc:  Math.floor((- result[item][0].minSellValue/fromTcPrice + result[item][1].minSellValue/toTcPrice)*100) / 100,
            itemName: item,
            profitViable: (result[item][0].minSellValue/fromTcPrice == 0 || result[item][1].minSellValue/toTcPrice == 0) ? false : true
            
          })
        }
        state.transferItems = structuredData;
      })



    },

    getCategoryPrices: async (state, data) => {
      state.pricesLoaded = false;
      state.itemPrices = {};
      await dbRequests.get(`/market/items/worlds/${data.world}?category=${data.category}`).then((res) => {
        const auxResponse = res.data.data;
        let aux = {};
        for (let i = 0; i < auxResponse.length; i++) {
          if (auxResponse[i].itemName in aux) {
            aux[auxResponse[i].itemName].push(auxResponse[i]);
          } else {
            aux[auxResponse[i].itemName] = [auxResponse[i]];
          }
        }
        state.itemPrices = {};
        let items = Object.keys(aux);

        for (let i = 0; i < items.length; i++) {
          aux[items[i]].sort(function (a, b) {
            return new Date(b.timestamp) - new Date(a.timestamp)
          })
        }

        state.itemPrices = aux

        state.pricesLoaded = true

      })
    },
    getItemsByItemName: async (state, itemName) => {
      let category = getCategory(itemName, state.items)

      state.pricesLoadedByItemId = false;

      await dbRequests.get(`/market/items/item?category=${category}&item=${itemName}`).then((res) => {
        const auxResponse = res.data.data
        let worldPrices = {}
        state.itemPricesByItemId = []
        for (let i = 0; i < auxResponse.length; i++) {
          if (auxResponse[i].world in worldPrices) {
            worldPrices[auxResponse[i].world].push(auxResponse[i])
          } else {
            worldPrices[auxResponse[i].world] = [auxResponse[i]]
          }
        }
        const worlds = Object.keys(worldPrices)
        let response = []
        for (let i = 0; i < worlds.length; i++) {
          const world = worlds[i]

          worldPrices[world].sort((a, b) => {
            return new Date(b.timestamp) - new Date(a.timestamp)
          })
          let change = 0;
          if (worldPrices[world].length > 1) {
            change = Math.floor(((worldPrices[world][0].minSellValue) * 100 / worldPrices[world][1].minSellValue - 100) * 100) / 100;

          }

          if (!change) {
            change = 0;
          } else if (change == Infinity) {
            change = 100
          }
          response.push(

            {
              ...worldPrices[world][0],
              change: change
            }
          );

        }


        state.itemPricesByItemId = response;
        state.pricesLoadedByItemId = true;

      })
    },
    setSearchOption(state, option) {
      state.searchOption = option
    },
    login: async (state, user) => {
      await dbRequests.post('client/auth', {
        username: user.username,
        password: user.password
      }).then((res) => {
        
        changeAuthToken(res.data.data.data.token)
        state.user = res.data.data.data
        state.loginResponse = ""

        router.push('/')
      }).catch(() => {
        state.loginResponse = "Authentification failed"
      })
    }

  },
  actions: {

    getWorlds: async ({ commit }) => {

      await dbRequests.get('/worlds').then((res) => {
        commit('setWorlds', res.data)
      })
    },
    getItems: async ({ commit }) => {

      await dbRequests.get('/market/items').then((res) => {
        commit('setItems', res.data)
        commit('setCategories', res.data)
      })

    },

  },
  modules: {
  }
})

function getCategory(itemName, items) {
  let category = ''
  const categories = Object.keys(items.data);
  for (let i = 0; i < categories.length; i++) {
    const itemsInCat = items.data[categories[i]]
    for (let k = 0; k < itemsInCat.length; k++) {
      if (itemsInCat[k].itemName == itemName) {
        category = categories[i];
        break;
      }
    }
  }
  return category
}

function changeAuthToken(token) {
  dbRequests = axios.create({
    baseURL: 'https://tibiawallstreet.herokuapp.com/api/v1',
    // baseURL: 'http://localhost:3000/api/v1',
    timeout: 20000,
    headers: {
      'authorization': token,
      'content-type': "application/json"
    }
  })
}
 